<div class="container-fluid">
  <nav class="navbar navbar-expand">
    <button
      class="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse w-100" id="navbarSupportedContent">
      <ul class="navbar-nav w-100 justify-content-between">
        <li class="nav-item flex-fill text-center">
          <a
            class="nav-link"
            routerLink="overview"
            routerLinkActive="active-link"
            >Overview</a
          >
        </li>
        <li class="nav-item flex-fill text-center">
          <a
            class="nav-link"
            routerLink="announcement"
            routerLinkActive="active-link">
			All Announcement</a>
        </li>
		 <li class="nav-item flex-fill text-center">
          <a
            class="nav-link"
            routerLink="courses"
            routerLinkActive="active-link">Courses</a>
        </li>
		 <li class="nav-item flex-fill text-center">
          <a
            class="nav-link"
            routerLink="quizzes"
            routerLinkActive="active-link">Quizzes</a>
        </li>
		 <li class="nav-item flex-fill text-center">
          <a
            class="nav-link"
            routerLink="study-materials"
            routerLinkActive="active-link">Study Materials</a>
        </li>
        <li class="nav-item flex-fill text-center">
          <a class="nav-link" routerLink="member" routerLinkActive="active-link"
            >Members</a
          >
        </li>
      </ul>
    </div>
  </nav>
</div>
